export default __webpack_public_path__ + "static/media/PROTAL_LOGO3.46253832.svg";